import {Col, Row} from "react-bootstrap";
import {InfoIcon} from "../InfoIcon";
import React from "react";
import * as PropTypes from "prop-types";

export function SurveySectionHeader(props) {
	return <Row>
		<Col xs={12}>
			{
				props.section.name != "" ?
					<h3>
						{props.section.name}
						<InfoIcon link={props.section.infoLink}>{props.section.infoTitle}</InfoIcon>
					</h3> :
					null
			}
			{
				props.section.description ?
					<p className="description">{props.section.description}</p> :
					null
			}
		</Col>
	</Row>;
}

SurveySectionHeader.propTypes = {section: PropTypes.any};